var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":true,"no-wrap":"","variant":"white","opacity":"1","blur":"50px"},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('section',{staticClass:"overlay-content"},[_c('div',{staticClass:"spinner-border text-info",attrs:{"role":"status"}}),_c('p',[_vm._v(_vm._s(_vm.msg))])])]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }